// Support Enums
export enum SupportTicketStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED'
}

export enum SupportMessageSource {
  USER = 'USER',
  ADMIN = 'ADMIN'
}

// Support DTOs
export interface SupportAttachmentDto {
  id: number;
  fileName: string;
  fileSize: number;
  contentType: string;
  uploadedAt: string;
}

export interface SupportMessageDto {
  id: number;
  userId: number;
  username: string;
  message: string;
  source: SupportMessageSource;
  createdAt: string;
  attachments: SupportAttachmentDto[];
}

export interface SupportTicketDto {
  id: string;
  userId: number;
  username: string;
  subject: string;
  status: SupportTicketStatus;
  isReadByAdmin: boolean;
  isReadByUser: boolean;
  createdAt: string;
  updatedAt: string;
  messages: SupportMessageDto[];
  assigneeId?: number | null;
  assigneeUsername?: string | null;
}

export interface SupportTicketSummaryDto {
  id: string;
  userId: number;
  username: string;
  subject: string;
  status: SupportTicketStatus;
  isReadByAdmin: boolean;
  isReadByUser: boolean;
  messageCount: number;
  createdAt: string;
  updatedAt: string;
  isFavorite?: boolean;
  assigneeId?: number | null;
  assigneeUsername?: string | null;
}

export interface PaginatedSupportTicketDto {
  content: SupportTicketSummaryDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}

export interface CreateSupportTicketDto {
  subject: string;
  message: string;
  files?: File[];
}

export interface AddSupportMessageDto {
  message: string;
  files?: File[];
}

export interface FavoriteStatusDto {
  favorite: boolean;
}

export interface AssigneeDto {
  id: number;
  username: string;
  role: string;
}
